// The empty state of a list that answers from the viewer's scope: the firm
// wording for admin+, otherwise `mine` plus a sentence that holds for any
// viewer, an unconfirmed identity included.

import { useCurrentUser } from "../auth/CurrentUserContext";
import { isAdminRole } from "../../lib/roles";

export function EmptyCopy({ title, body, mine }: { title: string; body: string; mine: string }) {
  const isAdmin = isAdminRole(useCurrentUser()?.role);
  return (
    <>
      <div className="title">{isAdmin ? title : mine}</div>
      <div className="body">
        {isAdmin ? body : "Only the matters you can see are counted here."}
      </div>
    </>
  );
}
